import {CacheDriverInterface} from './../types'
import BaseEngine from './BaseEngine'

export default class PlainLocalStorageDriver extends BaseEngine implements CacheDriverInterface {
  storage = localStorage
}
